import
{
    useL10n
} from "@ews/react-localization-context";
import { IonText } from "@ionic/react";

import
{
    FC,
    useEffect,
    useState
} from "react";


export type ValidityCountDownProps = {
    validFrom: Date,
    validTo: Date;
};

const formatPart = (n: number) =>
{
    return `${Math.floor(n)}`.padStart(2, '0');
};

const createDate = (date: Date) =>
{
    const dateString = `${date}`;
    return new Date(dateString);
};

const ValidityCountDown: FC<ValidityCountDownProps> = ({
    validFrom,
    validTo
}) =>
{
    const now = new Date();
    const from = createDate(validFrom);
    const to = createDate(validTo);
    const isInFuture = now.getTime() < from.getTime();
    const delta = isInFuture ? (now.getTime() - from.getTime()) : (to.getTime() - now.getTime());
    const timeLeft = Math.floor(delta / 1000);

    const { translate: t } = useL10n();
    const [isExpired, setIsExpired] = useState<boolean>(false);
    const [tick, tickNext] = useState<boolean>(true);

    console.log(from, validFrom, now, to, validTo);

    useEffect(() =>
    {
        setIsExpired(now.getTime() > to.getTime());
    }, [to]);

    useEffect(() =>
    {
        let timeout: number;
        const setTimer = () =>
        {
            if (!isExpired) tickNext(!tick);
            if (timeLeft < 0 && !isInFuture) setIsExpired(true);
        };

        timeout = window.setTimeout(setTimer, 1000);
        return () => clearTimeout(timeout);
    });

    if (isExpired) return <IonText style={{ float: "right" }}>{t('COM_FACPMANAGEMENT_SHARES_OUTOFTIME')}</IonText>;
    const [sign, value] = [Math.sign(timeLeft), Math.abs(timeLeft)];
    return <IonText style={{ float: "right" }}>{sign < 1 ? '-' : ''} {formatPart(value / 3600)}:{formatPart((value / 60) % 60)}:{formatPart(value % 60)}</IonText>;

};

export default ValidityCountDown;
